module.exports = __webpack_public_path__ + "media/images/pic/groups/youth-440ae82d511dd4755121766b1a788937.jpg";